module.exports = __webpack_public_path__ + "img/dongbei.15e28fc0.png";